import { Show } from "solid-js";
import { Package } from "@fleet/icons";
import { cn } from "@stockpilot/shared";
import type { SearchResult } from "./command-palette.types";

interface ResultItemProps {
  item: SearchResult;
  index: number;
  activeIndex: number;
  globalIndex: number;
  onSelect: () => void;
  onHover: (globalIndex: number) => void;
}

export function ResultItem(props: ResultItemProps) {
  const isActive = () => props.activeIndex === props.globalIndex;

  return (
    <button
      type="button"
      data-active={isActive()}
      class={cn(
        "flex items-center gap-2.5 w-full py-[9px] px-2.5 rounded-[10px] border-none bg-transparent cursor-pointer text-left transition-colors duration-80 ease-out text-foreground hover:bg-[color-mix(in_oklch,var(--accent)_70%,transparent)]",
        isActive() &&
          "bg-[color-mix(in_oklch,var(--primary)_10%,var(--accent)_60%)] active hover:bg-[color-mix(in_oklch,var(--primary)_10%,var(--accent)_60%)]",
      )}
      onClick={() => {
        props.onSelect();
      }}
      onPointerEnter={() => {
        props.onHover(props.globalIndex);
      }}
    >
      <span class="flex items-center justify-center w-7 h-7 rounded-lg shrink-0 bg-[color-mix(in_oklch,var(--primary)_12%,transparent)] text-[var(--primary)] transition-colors duration-80 ease-out">
        <Package class="h-4 w-4" />
      </span>

      <span class="flex-1 min-w-0">
        <span class="block text-[13.5px] font-[450] truncate tracking-[-0.01em]">
          {props.item.text}
        </span>
        <Show when={props.item.sku}>
          <span class="block text-[11px] text-muted-foreground truncate">{props.item.sku}</span>
        </Show>
      </span>
    </button>
  );
}
